import { render, staticRenderFns } from "./ChineseReportFindingItems.vue?vue&type=template&id=7c54ffb1&scoped=true"
import script from "./ChineseReportFindingItems.vue?vue&type=script&lang=js"
export * from "./ChineseReportFindingItems.vue?vue&type=script&lang=js"
import style0 from "./ChineseReportFindingItems.vue?vue&type=style&index=0&id=7c54ffb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54ffb1",
  null
  
)

export default component.exports